import request from './axios'

//  亲情号码/白名单列表
export const telephoneBookList =  (params) => {
    return request({
        url: "/device/telephoneBookList",
        method: "get",
        params,
    })
}
//  添加 亲情号码/白名单 
export const createOrUpdate =  (params) => {
    return request({
        url: "/device/telephoneBook/createOrUpdate",
        method: "post",
        data: params,
    })
}
//  上课隐身/上课禁用-查询
export const hiding =  (params) => {
    return request({
        url: "/device/hiding",
        method: "get",
        params,
    })
}
//  上课隐身/上课禁用-新增
export const hidingadd =  (params) => {
    return request({
        url: "/device/hiding/add",
        method: "post",
        data: params,
    })
}
//  上课隐身/上课禁用-修改
export const hidingUpdate =  (data) => {
    return request({
        url: `/device/hiding/update`,
        method: "post",
        data
    })
}
//  上课隐身/上课禁用-删除
export const hidingdelete =  (params) => {
    return request({
        url: "/device/hiding/delete",
        method: "DELETE",
        params,
    })
}
//  闹钟  列表
export const alarmClock =  (params) => {
    return request({
        url: "/device/alarmClock",
        method: "get",
        params,
    })
}
//  闹钟  新增
export const addAlarmClock =  (params) => {
    return request({
        url: "/device/addAlarmClock",
        method: "post",
        data: params,
    })
}
//  闹钟  删除
export const deleteAlarmClock =  (params) => {
    return request({
        url: "/device/deleteAlarmClock",
        method: "DELETE",
        params,
    })
}
//  闹钟  修改
export const updateAlarmClock =  (params) => {
    return request({
        url: "/device/updateAlarmClock",
        method: "get",
        params,
    })
}
//  休眠  查询
export const deviceSleep =  (params) => {
    return request({
        url: "/device/sleep",
        method: "get",
        params,
    })
}
//  休眠  修改
export const sleepUpdate =  (params) => {
    return request({
        url: "/device/sleep/update",
        method: "post",
        data:params,
    })
}
//  定位评率  查询
export const locationFrequency =  (params) => {
    return request({
        url: "/device/locationFrequency",
        method: "get",
        params,
    })
}
//  定位评率  新增
export const locationFrequencyAdd =  (params) => {
    return request({
        url: "/device/locationFrequency/add",
        method: "post",
        data: params,
    })
}
//  定位评率  删除
export const locationFrequencyDelete =  (params) => {
    return request({
        url: "/device/locationFrequency/delete",
        method: "DELETE",
        params,
    })
}
//  定位评率  修改
export const locationFrequencyUpdate =  (params) => {
    return request({
        url: "/device/locationFrequency/update",
        method: "post",
        data:params,
    })
}
//  定位评率  修改开关与时间间隔
export const onOffTimeUpdate =  (params) => {
    return request({
        url: "/device/locationFrequency/onOffTime/update",
        method: "get",
        params,
    })
}
//  立即定位接口
export const deviceLocate =  (params) => {
    return request({
        url: "/device/immediatelyLocate",
        method: "get",
        params,
    })
}
//  立即定位接口
export const exerciseCountStep =  (params) => {
    return request({
        url: "/device/exerciseCountStep",
        method: "get",
        params,
    })
}
//  围栏设置 获取
export const circleFind =  (params) => {
    return request({
        url: "/device/circle/find",
        method: "get",
        params,
    })
}
//  围栏设置 新增
export const circleAdd =  (params,imei) => {
    return request({
        url: `/device/circle/add?imei=${imei}`,
        method: "post",
        data:params,
    })
}
//  围栏设置 删除
export const circleDelete =  (params) => {
    return request({
        url: `/device/circle/delete`,
        method: "DELETE",
        params,
    })
}
//  围栏设置 修改
export const circleUpdate =  (params,id) => {
    return request({
        url: `/device/circle/update?id=${id}`,
        method: "post",
        data:params,
    })
}

//sos查询
export const SosList =  (params) => {
    return request({
        url: "/device/sosList",
        method: "get",
        params,
    })
}
//sos新增/修改
export const sosUpdate =  (imei,params) => {
    return request({
        url: `/device/sos/update?imei=${imei}`,
        method: "post",
        data:params,
    })
}

//重新激活

export const  chongxinDevice =  (deviceId ) => {
    return request({
        url: `/device/resetActive?deviceId=${deviceId }`,
        method: "post",

    })
}
//设备详情查找
export const deviceGetFind =  (params) => {
    return request({
        url: "/device/find",
        method: "get",
        params,
    })
}
//恢复出厂设置
export const resetFactory = (params) => {
    return request({
      url: `/device/resetFactory`,
      method: "get",
      params:params,
    });
  };